import { apiRequest } from "./apiClient"
import { ALL_FACILITY_CODES } from "src/constants/facilities"
import type { Supplier } from "src/types/supplier"
import type { SupplierMetrics } from "src/types/supplierMetrics"

export function getSuppliers(facility: string): Promise<{ data: Supplier[] }> {
  return apiRequest(`/suppliers?facility=${encodeURIComponent(facility)}`)
}

export function getSupplierMetrics(facility: string, supplierCode: string): Promise<SupplierMetrics> {
  return apiRequest(`/suppliers/${encodeURIComponent(supplierCode)}/metrics?facility=${encodeURIComponent(facility)}`)
}

export function getSupplierItem(facility: string, supplierCode: string): Promise<Supplier> {
  return apiRequest(`/suppliers/${encodeURIComponent(supplierCode)}?facility=${encodeURIComponent(facility)}`)
}

/**
 * Look up a single supplier by code. Tries the active facility first, then
 * falls back to the other facilities (a supplier may be configured elsewhere).
 * Returns null if not found anywhere.
 */
export async function findSupplierByCode(
  facility: string,
  code: string,
): Promise<Supplier | null> {
  const inActive = (await getSuppliers(facility)).data ?? []
  const found = inActive.find((s) => s.code === code)
  if (found) return found

  const others = ALL_FACILITY_CODES.filter((f) => f !== facility)
  const results = await Promise.all(
    others.map((f) =>
      getSuppliers(f)
        .then((r) => (r.data ?? []).find((s) => s.code === code) ?? null)
        .catch(() => null),
    ),
  )
  return results.find((r) => r !== null) ?? null
}
